import {
  DynamicVariable,
  assignInlineVars,
} from "@faire/deprecated-retailer-visitor-shared/lib/tailwindUtils";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";
import { cn } from "@faire/web/tools/cn";
import range from "lodash/range";
import * as React from "react";

export const ROWS_PER_BATCH = 2;

interface IProps {
  itemsPerRowResponsive: ResponsiveValues<number>;
}

const varMobileNumColumns: DynamicVariable<"--f-sph-nc-m"> = {
  variable: "--f-sph-nc-m",
  className: "col-(--f-sph-nc-m)",
};

const varTabletNumColumns: DynamicVariable<"--f-sph-nc-md"> = {
  variable: "--f-sph-nc-md",
  className: "md:col-(--f-sph-nc-md)",
};

const varDesktopNumColumns: DynamicVariable<"--f-sph-nc-lg"> = {
  variable: "--f-sph-nc-lg",
  className: "lg:col-(--f-sph-nc-lg)",
};

const varXLargeNumColumns: DynamicVariable<"--f-sph-nc-xl"> = {
  variable: "--f-sph-nc-xl",
  className: "xl:col-(--f-sph-nc-xl)",
};

export const SingleProductRowPlaceholder: React.FC<IProps> = ({
  itemsPerRowResponsive,
}) => {
  const vars = assignInlineVars({
    [varMobileNumColumns.variable]: `1/${String(itemsPerRowResponsive.mobileAndAbove + 1)}`,
    [varTabletNumColumns.variable]: `1/${String(
      (itemsPerRowResponsive.tabletAndAbove ?? 2) + 1
    )}`,
    [varDesktopNumColumns.variable]: `1/${String(
      (itemsPerRowResponsive.desktopAndAbove ?? 5) + 1
    )}`,
    [varXLargeNumColumns.variable]: `1/${String(
      (itemsPerRowResponsive.xLargeAndAbove ?? 6) + 1
    )}`,
  });

  return (
    <>
      {range(ROWS_PER_BATCH).map((value) => (
        <div
          className={cn(
            "h-[340px] w-full max-w-full md:h-[375px] lg:h-[440px]",
            varMobileNumColumns.className,
            varTabletNumColumns.className,
            varDesktopNumColumns.className,
            varXLargeNumColumns.className
          )}
          style={vars}
          key={value}
          data-test-id={`single-row-placeholder-${value}`}
        />
      ))}
    </>
  );
};
